export default __webpack_public_path__ + "static/media/infoIllustration4.a6edb6d5.gif";